<template>
    <flex-layout>
        <ComplaintModal />
        <page-header heading="Complaints">
            <template v-slot:export>
                <a :href="uri + '/export'">
                    <button class="btn btn-sm btn-outline-danger"><i class="ic-checklist"></i>Export</button>
                </a>
            </template>
        </page-header>
        <ComplaintTable :tableHeading="tableHeading" />
    </flex-layout>
</template>
  
<script>
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import ComplaintTable from "@/components/Complaint/table.vue";
import PageHeader from "@/components/Utility/PageHeader.vue";
import ComplaintModal from "@/components/Complaint/modal.vue";
export default {
    name: "Complaints",
    components: {
        PageHeader,
        FlexLayout,
        ComplaintTable,
        ComplaintModal
    },
    data() {
        return {
            uri: process.env.VUE_APP_API_URL + 'complaints',
            tableHeading: [
                {
                    heading: "Name",
                },
                {
                    heading: "Subject",
                },
                {
                    heading: "Message",
                },
                {
                    heading: "Status",
                },
                {
                    heading: 'Submitted on'
                }
            ],
        };
    },

};
</script>
  